export const RQMainKey = {
  locationFavorite: ['locationFavorite'] as const,
  locationTop10: (location: string) => ['locationTop10', location] as const,
  reservationTop10: ['reservationTop10'] as const,
  reviewTop10: ['reviewTop10'] as const,
  popularLocations: ['popularLocations'] as const,
  random4: ['random4'] as const,
};
